<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">采购发货</div>
      <div class="title--button">
        <printViewBtn :changeList="changeList" :modules="32"
          :printFun="pmgtPurchasesReceiptDoc_cooperativeSupplierPurchasesReceiptDocView"></printViewBtn>
      </div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="purchaseOrderSearch"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
    </my-operate>
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    ></myHtml>
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <!-- 详情 -->
    <myOrderDetails
      v-if="htmlDataDialogState.show2"
      :visible="htmlDataDialogState.show2"
      :homeIndex="16"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderDetails>
    <!-- 发货 -->
    <myOrderAdd
      v-if="htmlDataDialogState.show1"
      :visible="htmlDataDialogState.show1"
      :homeIndex="16"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderAdd>
  </div>
</template>
<script>
import { selcetSetting, updateSetting, _debounce } from '@/utils/myUtils';
import {
  pmgtPurchasesReceiptDoc_cooperativeSupplierPurchasesReceiptDocList,
  pmgtPurchasesReceiptDoc_cooperativeSupplierPurchasesReceiptDocView
} from '@/api/myController/purchase';
export default {
  name: 'purchase_storage',
  props: {},
  components: {},
  data() {
    return {
      pmgtPurchasesReceiptDoc_cooperativeSupplierPurchasesReceiptDocView,
      changeList: [],
      // 新增、详情、修改
      htmlDataDialogState: {
        show1: false,
        show2: false,
        show3: false
      },
      routeType: 0,
      routeQuery: {},
      homeIndex: 0,
      // ------------------------------
      listQuery: {
        customerName: '', // 账户编号
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      // 操作栏数据
      operationTitleData: [],
      // 排序
      orderParam: {
        asc: false,
        dateAggregateBy: '',
        fieldName: 'createTime'
      },
      // 操作栏数据
      titleOperationTitleData: [
        {
          name: '基本信息',
          value: 'searchString',
          type: 'text'
        },
        { name: '搜索', type: 'button' },
        { name: '新增', type: 'button' }
      ],
      listLoading: false,
      columnType: 'columnAll', // columnIndex序号,columnBox复选框
      // 按钮集合
      tableBtnList: ['详情'],
      // 表内容
      list: [],
      // 表头
      titleList: [
        {
          id: 0,
          name: '产品图片',
          value: 'baseImgUrl',
          fixedState: false,
          isShow: true,
          dataType: 'image',
          canEdit: false,
          width: 84
        },
        {
          id: 1,
          name: '入库日期',
          value: 'baseEntranceHomeTime',
          fixedState: false,
          isShow: true,
          dataType: 'dateTime',
          canEdit: false,
          width: 106,
          sortable: true
        },
        {
          id: 0,
          name: '入库单号',
          value: 'purchasesReceiptDocNumber',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          selectOptionKey: '',
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          color: '#409eff',
          width: 111,
          sortable: true
        },
        {
          id: 1,
          name: '标题',
          value: 'docName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 220,
          sortable: true
        },
        {
          id: 1,
          name: '全局搜索码',
          value: 'globalSearchNumber',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          color: '#049eff',
          canEdit: false,
          width: 120,
          sortable: true
        },
        // {
        //   id: 0,
        //   name: "关联采购单",
        //   value: "purchasesOrderDocId",
        //   fixedState: false,
        //   isShow: true,
        //   dataType: "text",
        //   selectOptionKey: "",
        //   selectOptionList: [],
        //   alwaysEditState: false,
        //   canEdit: false,
        //   color: "#409eff",
        //   width: 111,
        //   sortable: true,
        // },
        {
          id: 1,
          name: '供应商名称',
          value: 'baseSupplierName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 220,
          sortable: true
        },
        {
          id: 2,
          name: '入库产品',
          value: 'baseMaterialName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 139
        },
        {
          id: 3,
          name: '产品规格',
          value: 'specifications',
          fixedState: false,
          isShow: true,
          dataType: 'textList',
          canEdit: false,
          width: 200
        },
        {
          id: 6,
          name: '产品类别',
          value: 'baseMaterialTypeName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 120
        },
        {
          id: 4,
          name: '本次入库数量',
          value: 'baseEntranceHomeAmount',
          fixedState: false,
          isShow: true,
          dataType: 'numberAccuracy',
          canEdit: false,
          width: 79
        },
        {
          id: 41,
          name: '已入库数量',
          value: 'valueReceiptAmount',
          fixedState: false,
          isShow: true,
          dataType: 'numberAccuracy',
          canEdit: false,
          width: 84
        },
        {
          id: 51,
          name: '入库仓库',
          value: 'baseWarehouseWareName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 90
        },
        {
          id: 5,
          name: '已对账数量',
          value: 'valueReconciledAmount',
          fixedState: false,
          isShow: true,
          dataType: 'numberAccuracy',
          canEdit: false,
          width: 76
        },
        {
          id: 6,
          name: '含税单价',
          value: 'baseMaterialUnitprice',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 73
        },
        {
          id: 7,
          name: '未税单价',
          value: 'baseMaterialUnitpriceUntaxed',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 78
        },
        {
          id: 8,
          name: '税率(%)',
          value: 'baseTaxRate',
          fixedState: false,
          isShow: true,
          dataType: 'number',
          canEdit: false,
          width: 72
        },
        {
          id: 9,
          name: '含税总价',
          value: 'baseMaterialTotalprice',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 75
        },
        {
          id: 10,
          name: '未税总价',
          value: 'baseMaterialTotalpriceUntaxed',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 72
        },
        {
          id: 23,
          name: '已开票',
          value: 'valueInvoicedAmount',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 65
        },
        {
          id: 24,
          name: '未开票',
          value: 'valueUninvoicedAmount',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 65
        },
        {
          id: 55,
          name: '入库单状态',
          value: 'statusDoc',
          fixedState: false,
          isShow: true,
          dataType: 'customSelect',
          selectOptionList: [
            {
              label: '进行中',
              value: 0,
              color: 'white',
              backGroundColor: 'rgb(79,129,246)'
            },
            {
              label: '已完成',
              value: 1,
              color: 'white',
              backGroundColor: 'rgb(79,129,246)'
            },
            {
              label: '已终止',
              value: 2,
              color: 'white',
              backGroundColor: 'rgb(79,129,246)'
            }
          ],
          canEdit: false,
          width: 93
        },
        {
          id: 10,
          name: '审核状态',
          value: 'statusCheck',
          fixedState: false,
          isShow: true,
          dataType: 'customSelect',
          selectOptionKey: '',
          selectOptionList: [
            {
              label: '已审核',
              value: 1,
              color: 'white',
              backGroundColor: 'rgb(103,194,58)',
              fontSize: ''
            },
            {
              label: '未审核',
              value: 0,
              color: 'black',
              backGroundColor: 'rgb(220,223,230)',
              fontSize: ''
            }
          ],
          canEdit: false,
          width: 86
        },
        {
          id: 12,
          name: '对账状态',
          value: 'statusReconcile',
          fixedState: false,
          isShow: true,
          dataType: 'customSelect',
          selectOptionKey: '',
          selectOptionList: [
            {
              label: '超量对账',
              value: 3,
              color: 'white',
              backGroundColor: 'rgb(56,87,35)',
              fontSize: ''
            },
            {
              label: '完全对账',
              value: 2,
              color: 'white',
              backGroundColor: 'rgb(84,103,53)',
              fontSize: ''
            },
            {
              label: '部分对账',
              value: 1,
              color: 'white',
              backGroundColor: 'rgb(169,209,142)',
              fontSize: ''
            },
            {
              label: '未对账',
              value: 0,
              color: 'black',
              backGroundColor: 'rgb(220,223,230)',
              fontSize: ''
            }
          ],
          canEdit: false,
          width: 90
        },
        {
          id: 11,
          name: '收款状态',
          value: 'statusPayment',
          fixedState: false,
          isShow: true,
          dataType: 'customSelect',
          selectOptionKey: '',
          selectOptionList: [
            {
              label: '超量收款',
              value: 3,
              color: 'white',
              backGroundColor: 'rgb(56,87,35)',
              fontSize: ''
            },
            {
              label: '完全收款',
              value: 2,
              color: 'white',
              backGroundColor: 'rgb(84,103,53)',
              fontSize: ''
            },
            {
              label: '部分收款',
              value: 1,
              color: 'white',
              backGroundColor: 'rgb(169,209,142)',
              fontSize: ''
            },
            {
              label: '未收款',
              value: 0,
              color: 'black',
              backGroundColor: 'rgb(220,223,230)',
              fontSize: ''
            }
          ],
          canEdit: false,
          width: 90
        },
        {
          id: 13,
          name: '发票状态',
          value: 'statusInvoice',
          fixedState: false,
          isShow: true,
          dataType: 'customSelect',
          selectOptionKey: '',
          selectOptionList: [
            {
              label: '已开票',
              value: 1,
              color: 'white',
              backGroundColor: 'rgb(103,194,58)',
              fontSize: ''
            },
            {
              label: '未开票',
              value: 0,
              color: 'black',
              backGroundColor: 'rgb(220,223,230)',
              fontSize: ''
            }
          ],
          canEdit: false,
          width: 85
        },
        {
          id: 0,
          name: '产品图纸',
          value: 'baseDrawingFile',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 90
        },
        {
          id: 0,
          name: '产品附件',
          value: 'baseFileList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 90
        },
        {
          id: 0,
          name: '订单图片',
          value: 'valueImgList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 90
        },
        {
          id: 0,
          name: '订单附件',
          value: 'valueFileList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 90
        },
        {
          id: 0,
          name: '附加费用',
          value: 'extraFeeTotalAmount',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 90
        },
        {
          id: 11,
          name: '创建时间',
          value: 'createTime',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 177
        },
        {
          id: 0,
          name: '备注',
          value: 'remark',
          fixedState: false,
          isShow: true,
          dataType: 'textarea',
          canEdit: false,
          width: 90
        }
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = false;
      this.list = [];
      pmgtPurchasesReceiptDoc_cooperativeSupplierPurchasesReceiptDocList({
        orderParam: [this.orderParam],
        filter: this.purchaseOrderSearch,
        pmgtPurchasesOrderDocDetailDtoFilter: this.purchaseOrderSearch,
        pageParam: this.listQuery
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            try {
              for (let i = 1; i <= 50; i++) {
                // 详情
                let name1 = 'detail_ext' + i;
                let name2 = '122-ext' + i;
                item[name2] = item[name1];
                // 订单
                let name3 = 'main_ext' + i;
                let name4 = '121-ext' + i;
                item[name4] = item[name3];
                // 产品
                let name5 = 'product_ext' + i;
                let name6 = '1-ext' + i;
                item[name6] = item[name5];
              }
            } catch (error) {}
            try {
              item.specifications = JSON.parse(item.baseMaterialSpecDesc);
            } catch (error) {
              item.specifications = [];
            }
            try {
              if (item.baseBomVersion) {
                item.baseBomVersionV2 = 'V' + item.baseBomVersion;
              } else {
                item.baseBomVersionV2 = '---';
              }
            } catch (error) {}
          });
          this.list = res.data.data.dataList;
          this.listQuery.total = res.data.data.totalCount;
        } else {
          this.list = [];
        }
        this.listLoading = false;
        this.$refs.myOperate?.dragSortShow();
      });
    },
    async titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case '搜索':
          this.getList();
          break;
        case '新增':
          this.routeQuery = {};
          this.routeType = 0;
          this.htmlDataDialogState.show1 = true;
          break;
        default:
          break;
      }
    },
    // 操作栏点击事件
    operationBtnClick(item, titleData) {
      switch (item.name) {
        case '搜索':
          this.getList();
          break;
        default:
          break;
      }
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        case '详情':
          this.routeQuery = row;
          this.htmlDataDialogState.show2 = true;
          break;
        default:
          break;
      }
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        case '':
          break;

        default:
          break;
      }
    },
    // 多选
    selectChangeEvent(val) {
      this.changeList = val.records;
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records;
    },
    htmlDataDialogClose(state, data) {
      this.htmlDataDialogState.show1 = false;
      this.htmlDataDialogState.show2 = false;
      this.htmlDataDialogState.show3 = false;
      this.getList();
    },
    // 列宽拖动事件
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    // 开始拖拽事件
    onStart(titleList) {},
    // 拖拽结束事件
    onEnd(titleList) {
      this.titleList = titleList;
    },
    // 复选框事件
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    // 固定方向事件
    widthClick(titleList) {
      this.titleList = titleList;
    },
    // 重置
    async resetClick(titleList) {
      this.titleList = titleList;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
      justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.spanText {
  color: #1476c3;
  font-size: 14px;
}

.operations {
  float: left;
  width: 200px;
  padding-top: 6px;
}

/*  修改页面样式 */

.title--font {
  text-align: left;
  padding: 10px 0;
}
::v-deep .operation {
  margin-bottom: 10px;
}
::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}
::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}
::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}
::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
.title--button {
  right: 0;
  margin-top: 0.7%;
}
</style>
